// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hniZ","colMin":"styles_colMin__MkE1N"};